let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7Omhy"), load("kC80R")]).then(() => parcelRequire('7hGsm'));